import Permission from 'owa-service/lib/contract/Permission';
import { ComposeViewState, SharedFolderComposeViewState } from 'owa-mail-compose-store';
import {
    default as createComposeViewState,
    ComposeViewStateInitProps,
} from './createComposeViewState';

export interface SharedFolderComposeViewStateInitProps extends ComposeViewStateInitProps {
    isInSharedFolder: boolean;
    folderOwnerEmailAddress: string;
    folderPermission: Permission;
}

export default async function createSharedFolderComposeViewState(
    props: SharedFolderComposeViewStateInitProps
): Promise<SharedFolderComposeViewState> {
    const composeViewState: ComposeViewState = await createComposeViewState(props);
    const sharedFolderComposeViewState = composeViewState as SharedFolderComposeViewState;

    sharedFolderComposeViewState.isInSharedFolder = props.isInSharedFolder;
    sharedFolderComposeViewState.folderOwnerEmailAddress = props.folderOwnerEmailAddress;
    sharedFolderComposeViewState.folderPermission = props.folderPermission;

    return sharedFolderComposeViewState;
}
